import axios from "axios";
import { config } from "../Config";
import { getSelectedWorkspace } from "../services/workspace";
import { getIDToken } from "../services/firebase";

const authHeaders = async () => {
  const token = await getIDToken();
  const workspace = getSelectedWorkspace();

  const threadId = sessionStorage.getItem(`x-introist-assistant-thread-${workspace}`);

  const headers = {
    authorization: `Bearer ${token}`,
    "x-introist-workspace": workspace,
    "x-introist-assistant-thread-id": threadId
  };

  return { headers };
};

export const resetThread = async () => {
  const workspace = getSelectedWorkspace();
  sessionStorage.removeItem(`x-introist-assistant-thread-${workspace}`);
  return loadThread();
};

export const loadThread = async () => {
  const workspace = getSelectedWorkspace();

  return axios
    .get(`${config.agentApiUrl}/assistant/thread`, await authHeaders())
    .then(res => res.data)
    .then(data => {
      sessionStorage.setItem(`x-introist-assistant-thread-${workspace}`, data.thread_id);
      return data;
    });
};

export const reportThread = async (additionalInfo?: string) => {
  return axios
    .post(
      `${config.agentApiUrl}/assistant/report`,
      { additional_info: additionalInfo },
      await authHeaders()
    )
    .then(res => res.data);
};

export const sendMessage = async (message: string) => {
  return axios
    .post(`${config.agentApiUrl}/assistant/thread`, { message }, await authHeaders())
    .then(res => res.data);
};

export const streamMessage = async (
  message: string,
  callback: (event: { event: string; data: any }) => unknown
) => {
  const { headers } = await authHeaders();

  const res = await fetch(`${config.agentApiUrl}/assistant/thread/stream`, {
    method: "POST",
    headers: {
      ...(headers as Record<string, string>),
      "Content-Type": "application/json"
    },
    body: JSON.stringify({ message })
  });

  const reader = res.body?.getReader();
  const decoder = new TextDecoder();

  while (reader) {
    const { done, value } = await reader.read();

    const chunk = decoder.decode(value, { stream: true });

    const event = handleChunk(chunk);

    if (event.event === "done") {
      return event.data;
    } else {
      callback(event);
    }

    if (done) {
      break;
    }
  }
};

const handleChunk = (chunk: string): { event: string; data: any } => {
  const parts = chunk.split("\n\n");
  let event = "unknown";
  let data = null;

  for (const part of parts) {
    const lines = part.split("\n");

    for (const line of lines) {
      if (line.startsWith("event: ")) {
        event = line.slice(7).trim();
      } else if (line.startsWith("data: ")) {
        data = line.slice(6).trim();
      }
    }
  }

  try {
    const parsed = data ? JSON.parse(data) : "";
    return { event, data: parsed };
  } catch (err) {
    console.error("Failed to parse chunk data:", data, err);
    throw new Error("Something failed");
  }
};
